import { definePropType } from "@types-vue/props";
import { defineComponent, computed } from "vue";
export default defineComponent({
    props: {
        status: {
            type: definePropType(String),
            required: true
        },
        text: {
            type: String,
            required: true
        }
    },
    setup: function setup(props) {
        var statusClass = computed(function() {
            return "status-icon status-".concat(props.status);
        });
        return {
            statusClass: statusClass
        };
    }
});
